import {Component, ContentChild, ElementRef, Input, OnInit, Output, TemplateRef, EventEmitter} from '@angular/core';

@Component({
  selector: 'exg-data-table',
  templateUrl: './exg-data-table.component.html',
  styles: []
})
export class ExgDataTableComponent implements OnInit {

  @Input() containerClass = 'grid cols-12';
  @Input() allowMultiSelection = false;
  @Input() allowSingleSelection = false;
  @Input() selectSource: Array<any> = [];
  @Input() selectSourceRows: undefined | Array<any> = undefined;
  @Input() selectKey: string | null = null;
  @Input() displayStateMessage = 'Es wurden keine Daten gefunden!';
  @Input() displayState = 0;

  @ContentChild('headerTemplate') headerTemplate!: TemplateRef<ElementRef>;
  @ContentChild('rowTemplate') rowTemplate!: TemplateRef<ElementRef>;

  @Output() RowChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() ItemSelect: EventEmitter<number> = new EventEmitter<number>();
  @Output() RowDblClick: EventEmitter<number> = new EventEmitter<number>();

  private _rowSource: Array<any> = [];
  private _selectState = false;

  get rowSource(): Array<any> {
    return this._rowSource;
  }

  @Input() set rowSource(value: Array<any>) {
    this._rowSource = value;
    this._selectState = false;
  }

  clickrule = {prevent: false, timer: 0};

  // Current Selected Index of Data
  private _selectedRow = -1;
  get selectedRow(): number {
    return this._selectedRow;
  }

  set selectedRow(value: number) {
    this.clickrule.prevent = false;
    this.clickrule.timer = setTimeout(() => {
      if (!this.clickrule.prevent) {
        this._selectedRow = value;
        this.RowChange.emit(value);
      }
    }, 250);
  }

  /*Touch deviced triggers no dblclick. Tweak for touch devices*/
  private _tapped: boolean | number = false;

  onTouchStart(e: any, value: number): void {
    if (!this._tapped) {
      this._tapped = setTimeout(() => {
        this._tapped = false;
        // insert things you want to do when single tapped
      }, 250);
    } else {
      clearTimeout(this._tapped as number);
      this._tapped = false;
      this.RowDblClick.emit(value);
    }
  }


  onDblClick(value: number): void {
    if (!this._tapped) {
      this.clickrule.prevent = true;
      clearTimeout(this.clickrule.timer);
      this.RowDblClick.emit(value);
    }
  }

  constructor() {
  }

  ngOnInit(): void {
  }

  select(index: any, value: any): void {

    const key = this.rowSource[index][(this.selectKey as string)];
    this.doSelect(key, value);
    this.ItemSelect.emit(this.selectSource.length);

  }

  selectClick(e: Event, index: any): void {
    e.preventDefault();
    e.stopPropagation();
    this.select(index, !this.isSelected(index));
  }

  private doSelect(key: any, value: any): void {
    const pos = this.selectSource.indexOf(key);
    if (value === true) {
      if (pos === -1) {
        this.selectSource.push(key);
        if (this.selectSourceRows) {
          this.selectSourceRows.push(this.rowSource.find((e => {
            return e[this.selectKey as string] === key;
          })));
        }
      }
    }
    if (value === false) {
      if (pos > -1) {
        this.selectSource.splice(pos, 1);
        if (this.selectSourceRows) {
          this.selectSourceRows?.splice(pos, 1);
        }
      }
    }
  }

  private isSelected(index: any): boolean {
    return (this.selectSource.indexOf(this.rowSource[index][(this.selectKey as string)]) > -1);
  }

  private selectAll(value: boolean): void {
    this._selectState = value;
    this.rowSource.forEach((element) => {
      this.doSelect(element[(this.selectKey as string)], value);
    });
    this.ItemSelect.emit(this.selectSource.length);
  }
}
